import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getDeprecatedAccessModules} from 'src/openapi/admin/apis/LicenseAccessModulesApi';
import {useAppDispatch} from 'src/store/hooks';

import type {DeprecatedAccessModule} from 'src/openapi/admin/models/DeprecatedAccessModule';

export const useGetDeprecatedAccessModules = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(
        (signal?: AbortSignal) => apiDispatch(getDeprecatedAccessModules({signal})),
        [apiDispatch],
    );

    const {data, isLoading, loadData, loadingError} = useReadOnlyDataHook<DeprecatedAccessModule[]>({
        initValue: [],
        getDispatchAction,
        shouldLoadData: false,
    });

    return {data, isLoading, load: loadData, loadingError};
};
